import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import moment from 'moment';

const errorColor = { background: '#fde8e7', text: '#9b1f1f' };
const warningColor = { background: '#fdfbe7', text: '#9b991f' };

const ErrorLogsModal = (props) => {
  const { show, setShow, data } = props;

  const onHideModal = () => {
    setShow(false);
  };

  const renderLogInfo = () => {
    if (isEmpty(data)) {
      return false;
    }

    return (
      <div className="error-logs-modal-infos">
        <span>Bot: {data?.botName}</span>
        <span>Item: {data?.itemType}</span>
        <span>Sessão: {data?.sessionId}</span>
      </div>
    );
  };

  const renderItemStatus = () => {
    if (isEmpty(data)) {
      return false;
    }

    const { httpCode, when } = data;
    const style = httpCode > 499 ? errorColor : warningColor;
    const date = moment(when);

    return (
      <div className="error-logs-modal-status">
        <div
          className="error-logs-modal-status-code"
          style={{
            background: style.background,
          }}
        >
          <span
            style={{
              color: style.text,
            }}
          >
            {httpCode}
          </span>
        </div>
        <span>{date.format('DD/MM/YYYY')}</span>
        <span>{date.format('HH:mm')}</span>
      </div>
    );
  };

  const renderLogItemDetails = () => {
    if (isEmpty(data)) {
      return false;
    }
    const {
      _id,
      isOperational,
      details,
      errorType,
      date,
      botName,
      name,
      description,
      httpCode,
      stackTrace,
      botId,
      sessionId,
      companyId,
      itemId,
      itemType,
      when,
      __v,
      ...dataToShow
    } = data;

    return (
      <div className="error-logs-modal-details">
        <span>Error detalhado</span>
        <pre>{JSON.stringify(dataToShow, null, 2)}</pre>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHideModal} className="error-logs-modal">
      <Modal.Header>
        <Modal.Title className="error-logs-modal-title">
          Detalhes do erro
          {renderLogInfo()}
        </Modal.Title>
        {renderItemStatus()}
      </Modal.Header>
      <Modal.Body>
        <div className="error-logs-modal-divider" />
        {renderLogItemDetails()}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShow(false)}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorLogsModal;
